import { render, staticRenderFns } from "./filogix-navigation.vue?vue&type=template&id=4eee5dd1"
import script from "./filogix-navigation.vue?vue&type=script&lang=ts"
export * from "./filogix-navigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports